<ng-container [formGroup]="filterForm">
  <mat-toolbar class="mat-toolbar-transparent">
    <mat-icon>filter_list</mat-icon>
  </mat-toolbar>
  <div class="wrapper--spacing-horizontal">
    <mat-form-field class="full-width-field">
      <mat-label>{{ 'year' | translate }}</mat-label>
      <mat-select formControlName="year" data-test="filter-year">
        @for (year of years; track year) {
          <mat-option [value]="year">{{ year }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (cropEnabled) {
      <div class="flex--row flex--gutter">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'crop' | translate }}</mat-label>
          <input
            type="text"
            [placeholder]="'crop' | translate"
            matInput
            formControlName="cropId"
            [matAutocomplete]="cropAutocomplete"
            data-test="filter-crop"
          />
          <mat-autocomplete #cropAutocomplete="matAutocomplete" [displayWith]="displayCrop$() | async">
            @for (option of filteredCrops$ | async; track option) {
              <mat-option [value]="option.id" data-test="filter-crop-option">
                {{ option.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    }
    <div class="mat-button-row flex--justify-end">
      <button mat-button (click)="resetFilter()" [disabled]="(filterEnabled | async) === false" data-test="filter-reset">
        <mat-icon>clear</mat-icon> {{ 'resetFilter' | translate }}
      </button>
    </div>
  </div>
</ng-container>
